import { createTransform } from "redux-persist";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web and AsyncStorage for react-native

// Transform to exclude refreshModal from app slice
// [DOC] see:https://github.com/rt2zz/redux-persist?tab=readme-ov-file#transforms
const appTransform = createTransform(
  (inboundState) => {
    const { refreshModal, ...rest } = inboundState;
    return rest;
  },
  (outboundState) => outboundState,
  { whitelist: ["app"] },
);

const isDebug = () => {
  if (window._env_?.REDUX_DEVTOOLS) {
    return true;
  }

  const env = window._env_?.NODE_ENV;
  if (env === "production" || env === "staging") {
    return false;
  } else if (env === "develop") {
    return true;
  }
};

// Persist config
// ref: https://github.com/rt2zz/redux-persist
export const persistConfig = {
  key: "root",
  storage,
  debug: isDebug(),
  stateReconciler: autoMergeLevel2,
  transforms: [appTransform],
  // "lists" container data is not persisted, because the partial_data
  // behaviour to fetch items is not clean when reloading the page
  // Also, list items can be very heavy and exceed chrome's default quota
  blacklist: [
    "notify",
    "modal",
    "routing",
    "ajax",
    "lists",
    "orders",
    "erpOrders",
    "prices",
    "customers",
    "pictureFeedback", // Picture feedback is temporary user input, should not persist across refreshes
  ],
};
